import { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useModal } from '@/contexts/ModalContext';
import { useI18n } from '@/hooks/useI18n';
import { toast } from '@/hooks/useToast';
import { DashboardListsService } from '@/services/dashboard-lists.service';

/**
 * Anteprima dell'itinerario scelto, dalla pagina richieste e dai titoli dei viaggi nella
 * pagina pagamenti. La richiesta porta solo id e
 * titolo; la modale vuole l'itinerario nella forma della dashboard, quindi lo si chiede
 * al click. Stessa RPC della dashboard: i campi economici restano mascherati al cliente.
 *
 * Niente azioni nella modale: da qui si guarda e basta, l'unico pulsante apre la proposta.
 */
export const useChosenItineraryPreview = () => {
  const { t } = useI18n();
  const navigate = useNavigate();
  const { openModal } = useModal();
  /** Id dell'itinerario in caricamento, per lo spinner sul pulsante giusto. */
  const [loadingId, setLoadingId] = useState<string | null>(null);

  const openPreview = useCallback(
    async (itineraryId: string) => {
      setLoadingId(itineraryId);
      try {
        const itinerary = await DashboardListsService.getItinerary(itineraryId);
        if (!itinerary) throw new Error('not found');
        openModal('itinerary-details', {
          itinerary,
          onViewItinerary: (id: string) => navigate(`/itinerary-builder?itineraryId=${id}`),
        });
      } catch {
        toast({
          title: String(t('requests.chosenItineraryErrorTitle')),
          description: String(t('requests.chosenItineraryErrorDesc')),
          variant: 'destructive',
        });
      } finally {
        setLoadingId(null);
      }
    },
    [navigate, openModal, t]
  );

  return { openPreview, loadingId };
};
